<template>
  <el-image
    :src="value"
    class="img"
    fit="cover"
  >
    <div slot="placeholder" class="avatar-placeholder">
      <i class="el-icon-picture-outline"/>
    </div>
    <div slot="error" class="avatar-placeholder">
      <i class="el-icon-picture-outline"/>
    </div>
  </el-image>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.img {
  object-fit: cover;
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 35px;
  background: #f5f5f5;
  color: #e4e6e6;
}
</style>
